import { Injectable } from '@angular/core';

import { AlertService } from '@core/services/alert/alert.service';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { NewAccountService } from '@core/services/new-products/new-account.service';
import { ProductsService } from '@core/services/products/products.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class ReplenishCommand extends BaseProductCommand {
  readonly type = 'replenish';
  readonly title = 'Пополнить';
  readonly icon = 'replenish';
  readonly productType: ProductTypes[] = [
    ProductTypes.ACCOUNT,
    ProductTypes.CARD,
    ProductTypes.DEPOSIT,
    ProductTypes.SAVE_ACCOUNT
  ];

  readonly isInfoAction = false;
  readonly settingsNames = ['PAY/SELF_FREE'];
  readonly order = 2; // Второй в actions

  constructor(
    private navigationService: NavigationService,
    private alertService: AlertService,
    private productsService: ProductsService,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    if (NewAccountService.excludedAccountCurrencies.includes(context.data.currencyCode)) {
      await this.alertService.showInfoAlert('Для проведения операции обратитесь в офис Банка');
    } else {
      await this.navigationService.push('/payments/transfer/self', {
        queryParams: { corrAccId: context.data.id },
        state: { amount: context.data?.creditInformation?.overduePrincipal }
      });
    }
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): boolean {
    return this.productsService.checkReplenishmentPossibility(context.data);
  }
}
